import { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const BaseLayout: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {children}
      <ToastContainer position="bottom-left" />
    </div>
  );
};

export default BaseLayout;
